<template>
  <div class="vibela-landing vibela-csae">
    <div class="csae-wrap">
      <div class="container">
        <div class="pill">Kinderschutz</div>

        <h1>Child Safety <em>Standards</em><span class="title-dot">.</span></h1>

        <p class="lede">
          THE-FARIN LTD, die Betreiberin von Vibela, duldet keinerlei Form von Kindesmissbrauch oder
          sexueller Ausbeutung von Kindern (CSAE). Auf dieser Seite erfährst du, welche Standards wir
          dazu einhalten, über welche Wege sich Verstöße melden lassen und wer bei uns als
          Ansprechpartner für Kinderschutzfragen zur Verfügung steht.
        </p>

        <div class="card">
          <div class="card-title">Ansprechpartner für den Kinderschutz</div>
          <p style="margin-bottom: 4px">Vibela Kundensupport</p>
          <p style="margin-bottom: 0">E-Mail: <a href="mailto:csae@vibela.de">csae@vibela.de</a></p>
          <p style="margin-top: 10px; margin-bottom: 0; font-size: 15px">
            Nachrichten an diese Adresse gehen direkt an geschultes Personal, das Auskunft zu unseren
            Durchsetzungs- und Prüfprozessen geben und die notwendigen Schritte einleiten kann.
          </p>
          <p style="margin-top: 10px; margin-bottom: 0; font-size: 15px">
            <strong>Reaktionszeit:</strong> In der Regel bearbeiten wir eingehende Meldungen und
            Eskalationen innerhalb von 24 Stunden – bei dringenden Fällen entsprechend zügiger.
          </p>
        </div>

        <h2>Unsere Haltung zu Kindesmissbrauch und -ausbeutung</h2>
        <p>
          Vibela wendet sich ausnahmslos an erwachsene Nutzer:innen. Jegliche Inhalte,
          Verhaltensweisen oder Kontaktaufnahmen, die Minderjährige sexuell ausbeuten, gefährden,
          anzubahnen versuchen ("Grooming") oder ihnen auf andere Weise schaden, sind bei uns
          kategorisch verboten.
        </p>
        <p>Darunter fällt insbesondere:</p>
        <ul>
          <li>
            das Erstellen, Hochladen, Versenden, Speichern oder Teilen von Missbrauchsdarstellungen
            Minderjähriger ("Child Sexual Abuse Material", CSAM) – gleich ob als Bild, Video, Text
            oder computergeneriert;
          </li>
          <li>
            die gezielte Kontaktaufnahme zu Minderjährigen zum Zweck der sexuellen Ausbeutung
            ("Grooming");
          </li>
          <li>sexuelle Nötigung ("Sextortion") oder Drohungen gegenüber Minderjährigen;</li>
          <li>jegliche Form von Menschenhandel oder sexueller Ausbeutung von Kindern;</li>
          <li>
            die Nutzung von Vibela, um eine der genannten Handlungen anzubahnen, zu organisieren oder
            zu fördern.
          </li>
        </ul>

        <h2>Begriffserklärungen</h2>
        <p>
          Im Rahmen dieser Standards versteht sich unter CSAE (Child Sexual Abuse and Exploitation)
          insbesondere Folgendes:
        </p>
        <ul>
          <li>
            <strong>CSAM (Child Sexual Abuse Material):</strong> jede bildliche Darstellung – Foto,
            Video, Zeichnung oder computergeneriertes Material – eines Minderjährigen bei sexuellen
            Handlungen oder mit sexuell motiviertem Fokus auf Körperteile.
          </li>
          <li>
            <strong>Grooming:</strong> der gezielte Aufbau von emotionalem Vertrauen zu einem
            Minderjährigen mit dem Ziel der sexuellen Ausbeutung oder zur Vorbereitung von Missbrauch.
          </li>
          <li>
            <strong>Sextortion:</strong> die Drohung, intime Aufnahmen eines Minderjährigen zu
            veröffentlichen oder weiterzugeben, um dadurch weitere sexuelle Handlungen oder andere
            Vorteile zu erzwingen.
          </li>
          <li>
            <strong>Sexualisierung von Minderjährigen:</strong> jede Darstellung oder Förderung von
            Minderjährigen in sexuellem Zusammenhang oder sexualisiertem Kontext.
          </li>
          <li>
            <strong>Menschenhandel und Ausbeutung:</strong> das Angebot, die Nachfrage oder die
            Ermöglichung sexueller Ausbeutung von Minderjährigen.
          </li>
        </ul>
        <p>
          Jeder Inhalt, jedes Verhalten, jede Nachricht und jedes Konto, das gegen diese
          Definitionen verstößt, zieht Konsequenzen gemäß diesen Standards nach sich.
        </p>

        <h2>Konsequenzen und Durchsetzung</h2>
        <p>Ein Verstoß gegen diese Standards hat Folgendes zur Folge:</p>
        <ul>
          <li>sofortige, dauerhafte Sperrung des betroffenen Kontos;</li>
          <li>
            unverzügliche Entfernung der beanstandeten Inhalte, sobald wir davon Kenntnis erlangen;
          </li>
          <li>
            Meldung an die zuständigen Strafverfolgungsbehörden bzw. das National Center for Missing
            &amp; Exploited Children (NCMEC) oder die jeweils zuständige regionale Stelle, soweit
            gesetzlich vorgeschrieben oder angezeigt;
          </li>
          <li>
            Sicherung relevanter Daten im Rahmen unserer gesetzlichen Aufbewahrungspflichten, um
            Ermittlungen zu unterstützen.
          </li>
        </ul>
        <p>
          THE-FARIN LTD hält sich an die geltenden Kinderschutzgesetze und -vorschriften sowie an
          international anerkannte Standards, unter anderem die Empfehlungen der Tech Coalition zur
          Bekämpfung von Online-CSAE.
        </p>

        <h2>Verstöße melden</h2>
        <p>
          Verdächtige Inhalte, Profile oder Verhaltensweisen kannst du jederzeit direkt in der App
          über die Melde- bzw. Feedback-Funktion anzeigen. Jede eingehende Meldung wird von unserem
          Team geprüft und entsprechend dieser Standards behandelt.
        </p>
        <p>
          Alternativ erreichst du uns unter:
          <a href="mailto:csae@vibela.de">csae@vibela.de</a>
        </p>
        <p>
          Gemeldete Inhalte prüft unser Team, priorisiert Verdachtsfälle und eskaliert sie bei
          Bedarf. Bestätigt sich ein Verstoß, führt das zur Entfernung der Inhalte, zur
          Kontosperrung sowie – wo gesetzlich vorgeschrieben – zur Meldung an die zuständigen
          Behörden.
        </p>

        <h2>Selbstauskunft gegenüber Google Play</h2>
        <p>Im Rahmen unserer Erklärung in der Google Play Console bestätigen wir, dass wir:</p>
        <ul>
          <li>
            diese öffentlich einsehbaren CSAE-Standards pflegen und in der Play Console verlinken;
          </li>
          <li>einen In-App-Mechanismus für Nutzer-Feedback und CSAE-Meldungen bereitstellen;</li>
          <li>
            bei tatsächlicher Kenntnis von CSAE/CSAM angemessen reagieren, einschließlich Entfernung
            von Inhalten und Kontosperrung;
          </li>
          <li>
            die geltenden Kinderschutzgesetze einhalten und Verstöße den zuständigen Behörden melden,
            soweit vorgeschrieben;
          </li>
          <li>
            einen Ansprechpartner benennen, der CSAE-Meldungen von Google oder Behörden bearbeiten
            kann.
          </li>
        </ul>

        <div class="meta">
          Letzte Aktualisierung: 15.09.2026<br />
          Änderungsprotokoll: 15.09.2026 – Aktualisierung der Child Safety Standards für Vibela.
        </div>
      </div>
    </div>

    <!--    <the-footer variant="legal" />-->
    <!--    <signup-modal />-->
    <!--    <cookie-banner />-->
  </div>
</template>

<script>
// import { landingChromeMixin } from '../landingChrome';
// import CookieBanner from '../../../../components/LandingV2/CookieBanner.vue';
// import TheNav from '../../../../components/LandingV2/sections/TheNav.vue';
// import TheFooter from '../../../../components/LandingV2/sections/TheFooter.vue';
// import SignupModal from '../../../../components/LandingV2/signup/SignupModal.vue';

export default {
  name: 'CsaePage',
  // mixins: [landingChromeMixin],
  // components: { CookieBanner, TheNav, TheFooter, SignupModal },
};
</script>

<style scoped lang="scss">
/* Standalone Child Safety design (from the supplied CSAE.html), wrapped with
   the shared vibela nav + footer. Colour tokens are namespaced (--csae-*) so
   they don't cascade into the nav/footer, and map onto the Vibela tokens from
   tokens.css. */
.vibela-csae {
  --csae-bg-cream: var(--cream);
  --csae-ink: var(--ink);
  --csae-body-text: var(--mute);
  --csae-accent: var(--rose);
  --csae-accent-deep: var(--wine);
  --csae-accent-light: var(--coral);
  --csae-pill-bg: rgba(200, 37, 44, 0.08);
  --csae-pill-text: var(--wine);
  --csae-card-border: var(--line);

  position: relative;
  min-height: 100vh;
  background: radial-gradient(circle at 15% 0%, rgba(217, 71, 76, 0.16), transparent 45%),
  radial-gradient(circle at 85% 10%, rgba(200, 37, 44, 0.14), transparent 50%),
  var(--csae-bg-cream);
}

.csae-wrap {
  position: relative;
  overflow: hidden;
  padding: 56px 24px 80px;
}

.container {
  max-width: 760px;
  margin: 0 auto;
  font-family: 'Fraunces', Georgia, serif;
  color: var(--csae-body-text);
  line-height: 1.6;
}

.container *,
.container *::before,
.container *::after {
  box-sizing: border-box;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--csae-pill-bg);
  color: var(--csae-pill-text);
  font-family: 'Fraunces', Georgia, serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 20px;
}

.pill::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--csae-pill-text);
  display: inline-block;
}

.container h1 {
  font-family: 'Fraunces', Georgia, serif;
  font-weight: 500;
  font-size: 48px;
  line-height: 1.08;
  letter-spacing: -0.035em;
  color: var(--csae-ink);
  margin: 0 0 20px;
}

.container h1 em {
  font-style: italic;
  font-weight: 500;
  background: linear-gradient(90deg, var(--csae-accent-light), var(--csae-accent-deep));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  /* background-clip: text only paints inside the line box; the italic slant of
     the last letter overhangs it and gets clipped. Right padding widens the box
     and box-decoration-break: clone keeps it intact across wrapped lines. */
  padding-right: 0.12em;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}

.container h1 .title-dot {
  /* Pull the period back over the em's right padding so it stays tight against
     the gradient word instead of floating after a gap. */
  margin-left: -0.1em;
  color: var(--csae-ink);
}

.lede {
  font-size: 18px;
  color: var(--csae-body-text);
  max-width: 640px;
  margin: 0 0 36px;
}

.card {
  background: linear-gradient(135deg, #ffffff, #fbeeec);
  border: 1px solid var(--csae-card-border);
  border-radius: 20px;
  padding: 24px 28px;
  margin: 28px 0 44px;
  box-shadow: 0 4px 24px rgba(200, 37, 44, 0.08);
}

.card-title {
  font-family: 'Fraunces', Georgia, serif;
  font-weight: 500;
  color: var(--csae-ink);
  margin-bottom: 8px;
  font-size: 17px;
  letter-spacing: -0.02em;
}

.card a {
  color: var(--csae-accent);
  text-decoration: none;
  font-weight: 500;
}

.card a:hover {
  text-decoration: underline;
}

.container h2 {
  font-family: 'Fraunces', Georgia, serif;
  font-weight: 500;
  font-size: 30px;
  letter-spacing: -0.025em;
  color: var(--csae-ink);
  margin: 44px 0 14px;
}

.container p {
  font-size: 17px;
  color: var(--csae-body-text);
  margin: 0 0 16px;
}

.container ul {
  margin: 0 0 20px;
  padding-left: 22px;
}

.container li {
  font-size: 17px;
  color: var(--csae-body-text);
  margin-bottom: 10px;
}

.container strong {
  color: var(--csae-ink);
}

.container a {
  color: var(--csae-accent);
}

.meta {
  font-size: 14px;
  color: var(--csae-body-text);
  margin-top: 48px;
  border-top: 1px solid var(--csae-card-border);
  padding-top: 20px;
}

@media (max-width: 640px) {
  .csae-wrap {
    padding: 36px 18px 56px;
  }
  .container h1 {
    font-size: 34px;
    line-height: 1.12;
  }
  .pill {
    font-size: 12px;
    padding: 5px 12px;
    margin-bottom: 16px;
  }
  .lede {
    font-size: 16px;
    margin-bottom: 28px;
  }
  .card {
    padding: 18px 20px;
    border-radius: 16px;
    margin: 20px 0 32px;
  }
  .card-title {
    font-size: 15px;
  }
  .container h2 {
    font-size: 22px;
    margin: 32px 0 12px;
  }
  .container p,
  .container li {
    font-size: 15.5px;
  }
  .container ul {
    padding-left: 18px;
  }
  .meta {
    font-size: 13px;
    margin-top: 36px;
  }
}

@media (max-width: 380px) {
  .container h1 {
    font-size: 28px;
  }
  .card {
    padding: 16px;
  }
}
</style>
